/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Koulutus − CamAPS FX',
    titleMeta: 'Tarjoamme maksutonta verkkokoulutusta CamAPS FX -käyttäjille',
    descriptionMeta: 'Cambridge Diabetes Education Programme tarjoaa maksutonta ja sertifioitua verkkokoulutusta tyypin 1 diabetesta sairastaville henkilöille, vanhemmille ja huoltajille, koulujen henkilökunnalle ja terveydenhoidon ammattilaisille.',
    keywords: 'camaps koulutus, camaps fx koulutus,  ',
    localeMeta: 'fi_fi',
    mainHeader: 'Terveydenhuollon koulutus',
    mainSubHeader: 'Tue CamAPS FX:ää käyttäviä henkilöitä asiantuntijavetoisella koulutuksella.',
    gettingStartedHeader: 'Aloittaminen',
    step1Title: '<strong>Vaihe 1:</strong><br/>Lataa sovellus',
    step2Title: '<strong>Vaihe 2:</strong><br/>Luo tili',
    step3Title: '<strong>Vaihe 3:</strong><br/>Aloita välttämätön sovelluksensisäinen koulutus',
    step4Title: '<strong>Vaihe 4:</strong><br/>Yhdistä valitsemasi pumppu ja CGM (hoitotiimisi hyväksynnällä) tai tutustu sovellukseen <strong>virtuaalisessa tilassa</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Sertifioitu koulutus',
    trainingHeader: 'Sertifioitu koulutus',
    trainingHeader_2: 'Terveydenhuollon ammattilaisille',
    trainingHeader_3: 'Käyttäjäkoulutus',
    trainingHeaderText: 'MAKSUTON CamAPS FX -verkkokoulutus − Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP-koulutus',
    getTrained: 'Hanki koulutus',
    trainingHeaderIat: 'CamAPS FX -koulutus',
    trainingHeaderTextIat: 'Suorita välttämätön sovelluksen sisäinen koulutus ennen CamAPS FX -sovelluksen käyttöä.',
    trainingSubHeaderOneIat: 'Aloittaminen',
    trainingSubTextOneIat: 'Lataa CamAPS FX -sovellus. <br>Luo tili aloittaaksesi koulutuksen.',
    trainingSubHeaderTwoIat: 'Tarvitsetko apua sovelluksen asennuksessa?',
    trainingParaTwoStartIat: 'Käy meidän',
    trainingParaTwoEndIat: 'osiossa saadaksesi ohjeita.',
    websiteLinkHeadingSupportIat: 'Tuki',
    trainingSubHeaderThreeIat: 'Lisäresurssit',
    animationsYpsoPumpText: 'Animaatiot',
    animationsAndText: 'ja',
    animationsDanaText: 'Animaatiot (Dana-pumppu)',
    animationsFurtherText: 'Opi vaihe vaiheelta visuaalisten ohjeiden avulla.',
    webinarsText: 'Webinaarit',
    webinarsFurtherText: 'Katso asiantuntijoiden vetämiä sessioita sovelluksen käytöstä.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
